
<div class="h-full w-full flex flex-col gap-4">
    <div class="relative">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <lucide-icon [img]="icons.Search"></lucide-icon>
        </div>
        <input 
            type="search" 
            class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
            [(ngModel)]="searchQuery" 
            (input)="filterAssessCases()"
            placeholder="Search Assessment Case..."  />
    </div>
    <div class="h-full pb-4 overflow-y-auto">
        <ng-container *ngIf="filteredInterventionCases.length > 0; else emptyInterventionCases">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="px-4 py-3 w-14">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                No.
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-40">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Case No.
                                <lucide-icon
                                    (click)="sortList('case_id')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-96">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Summary
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-44 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created At
                                <lucide-icon
                                    (click)="sortList('created')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-40 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created By
                                <lucide-icon
                                    (click)="sortList('created_by_name')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-64 min-w-40">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Actions
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let case of filteredInterventionCases | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                        <th scope="row" class="px-4 py-4">
                            {{ i + 1 + (page - 1) * itemsPerPage }}
                        </th>
                        <th class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {{ case.case_id }}
                        </th>
                        <td class="px-4 py-4 whitespace-pre-line">{{ case.detail_of_situation }}</td>
                        <td class="px-4 py-4">{{ case.created | date: 'MM/dd/yyyy - HH:mm' }}</td>
                        <td class="px-4 py-4">{{ case.created_by_name }}</td>
                        <td *ngIf="this.isUserInTeam(case)" class="px-4 py-4">
                            <div class="flex flex-wrap gap-1">
                                <!-- THREAT ASSESSMENT TEAM BUTTON -->
                                <button 
                                    [attr.data-tooltip-target]="'intervention-tooltip-' + case.case_id + '-team'" data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded bg-gradient-to-b text-white flex items-center justify-center"                                    
                                    [ngClass]="{
                                        'from-nside-gray-100 to-nside-gray-200': case.threat_assessment_team_status === this.statusEnum.FormUndone,
                                        'from-green-500 to-green-600': case.threat_assessment_team_status === this.statusEnum.FormDone,
                                        'hidden': isStageReviewPending(case)
                                    }"
                                    (click)="$event.preventDefault(); isStageReviewPending(case) ? openModal('cancel review', case) : openModal('team', case);"
                                >
                                    <lucide-icon [img]="icons.Users" size="20"></lucide-icon>
                                </button>
                                <div [id]="'intervention-tooltip-' + case.case_id + '-team'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    {{ getTooltip(case.threat_assessment_team_status, 'Threat Assessment Team') }}
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                                <!-- THREAT ASSESSMENT SUMMARY BUTTON -->
                                <button 
                                    [attr.data-tooltip-target]="'intervention-tooltip-' + case.case_id + '-assess-summary'" data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded bg-gradient-to-b text-white flex items-center justify-center"
                                    [ngClass]="{
                                        'from-nside-gray-100 to-nside-gray-200': case.threat_assessment_summary === this.statusEnum.FormUndone,
                                        'from-blue-500 to-blue-700': case.threat_assessment_summary === this.statusEnum.FormDone,
                                        'from-amber-300 to-amber-500': case.threat_assessment_summary === this.statusEnum.ReviewPending,
                                        'from-green-500 to-green-600 cursor-not-allowed': case.threat_assessment_summary === this.statusEnum.ReviewComplete,
                                        'hidden': isStageReviewPending(case)
                                    }"
                                    [disabled]="case.threat_assessment_summary === this.statusEnum.ReviewComplete"
                                    (click)="$event.preventDefault(); isStageReviewPending(case) ? openModal('cancel review', case) : goToPage('form/threat-assessment-summary', case.case_id);"
                                >
                                    <lucide-icon [img]="icons.FileUser" size="20"></lucide-icon>
                                </button>
                                <div [id]="'intervention-tooltip-' + case.case_id + '-assess-summary'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    {{ getTooltip(case.threat_assessment_summary, 'Threat Assessment Summary') }}
                                <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                                <!-- ROAR ASSIGNMENT BUTTON -->
                                <button 
                                    [attr.data-tooltip-target]="'intervention-tooltip-' + case.case_id + '-roar'" data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded bg-gradient-to-b text-white flex items-center justify-center"
                                    [ngClass]="{
                                        'from-nside-gray-100 to-nside-gray-200': case.roar_assignment_form === this.statusEnum.FormUndone,
                                        'from-blue-500 to-blue-700': case.roar_assignment_form === this.statusEnum.FormDone,
                                        'from-amber-300 to-amber-500': case.roar_assignment_form === this.statusEnum.ReviewPending,
                                        'from-green-500 to-green-600': case.roar_assignment_form === this.statusEnum.ReviewComplete,
                                        'hidden': isStageReviewPending(case)
                                    }"
                                    (click)="$event.preventDefault(); isStageReviewPending(case) ? openModal('cancel review', case) : openModal('roar', case);"
                                >
                                    <lucide-icon [img]="icons.FileUser" size="20"></lucide-icon>
                                </button>
                                <div [id]="'intervention-tooltip-' + case.case_id + '-roar'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    {{ getTooltip(case.roar_assignment_form, 'ROAR Assignment Form') }}
                                <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                                <!-- REQUEST A REVIEW BUTTON -->
                                <button 
                                    [attr.data-tooltip-target]="'intervention-tooltip-' + case.case_id + '-review-request'" data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center"
                                    [ngClass]="{ 
                                        'hidden cursor-not-allowed': isAllRequiredFormsUndone(case) || isStageReviewPending(case) || !case.roar_forms_complete
                                    }"
                                    [disabled]="isAllRequiredFormsUndone(case) || isStageReviewPending(case) || !case.roar_forms_complete"
                                    (click)="$event.preventDefault(); openModal('review request', case);"
                                >
                                    <lucide-icon [img]="icons.SearchCheck" size="20"></lucide-icon>
                                </button>
                                <div [id]="'intervention-tooltip-' + case.case_id + '-review-request'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    Request A Review
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                            <div class="flex items-center justify-start">
                                <button 
                                    [attr.data-tooltip-target]="'intervention-tooltip-' + case.case_id + '-review-pending'" data-tooltip-placement="bottom"
                                    class="px-2 py-1.5 rounded bg-gradient-to-b from-amber-300 to-amber-400 hover:from-amber-400 hover:to-amber-500 flex items-center justify-center whitespace-nowrap text-white"
                                    [ngClass]="{ 'hidden': !isStageReviewPending(case) }"
                                    [disabled]="!isStageReviewPending(case)"
                                    (click)="$event.preventDefault(); openModal('cancel review', case);"
                                >
                                    Review Pending
                                </button>
                                <div [id]="'intervention-tooltip-' + case.case_id + '-review-pending'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    Cancel Review?
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    
        <ng-template #emptyInterventionCases>
            <div class="w-full text-nside-gray-100 italic">
                Empty Intervention Cases
            </div>
        </ng-template>
    </div>
    <div class="flex justify-between items-center">
        <p>{{ filteredInterventionCases.length }} in total</p>
        <pagination-controls
            *ngIf="filteredInterventionCases.length > itemsPerPage"
            (pageChange)="page = $event"
            previousLabel="Prev"
            nextLabel="Next"
            class="mt-2"
        ></pagination-controls>
    </div>
</div>

<assess-team class="w-screen"
    *ngIf="this.showTeam"
    [caseId]="this.selectedCase!.case_id"
    (onSave)="handleSave($event, 'team')"
    (onClose)="closeModal('team')"
></assess-team>

<review-request class="w-screen"
    *ngIf="this.showReviewRequest"
    [stage]="this.stageEnum.Interventions"
    [caseId]="this.selectedCase!.case_id"
    (onSend)="handleSave($event, 'review request')"
    (onClose)="closeModal('review request')"
></review-request>

<review-cancel
    *ngIf="this.showCancelReview"
    [stage]="this.stageEnum.Interventions"
    [caseId]="this.selectedCase!.case_id"
    (onSend)="handleSave($event, 'cancel review')"
    (onClose)="closeModal('cancel review')"
></review-cancel>

<roar-modal
    *ngIf="this.showRoarModal === true && this.selectedCase"
    [assessCase]="this.selectedCase"
    (onCreateNewRoar)="handleSave($event)"
    (goToForm)="goToPage($event.page, $event.caseId, $event.roarId)"
    (onClose)="closeModal('roar')"
></roar-modal>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>

